import { useQuery, UseQueryResult } from '@tanstack/react-query';

import { getStageItemsByStageId } from '@/actions/stage-items/getStageItemsByStageId';
import { ApiResponse } from '@/types/response.type';
import { StageItem } from '@/types/stage.item.type';

export interface UseGetStageItemsByStageIdReturn {
  result: ApiResponse<Array<StageItem>> | undefined;
  error: Error | null;
  isError: boolean;
  isLoading: boolean;
  isSuccess: boolean;
  isRefetching: boolean;
}

export const useGetStageItemsByStageId = (
  stageId: string
): UseGetStageItemsByStageIdReturn => {
  const query: UseQueryResult<ApiResponse<Array<StageItem>>, Error> = useQuery({
    queryKey: ['stage-items', stageId],
    queryFn: () => getStageItemsByStageId(stageId),
  });

  return {
    result: query.data,
    error: query.error,
    isError: query.isError,
    isSuccess: query.isSuccess,
    isLoading: query.isPending,
    isRefetching: query.isRefetching,
  };
};
